// src/pages/merchant/Activity.js
// Historique d'activité du marchand
// Maxula

import React, { useEffect, useState } from 'react';
import { FiActivity } from 'react-icons/fi';
import { verificationAPI } from '../../services/api';

const TYPE_LABELS = {
  deal_create: 'Création d\'annonce',
  deal_update: 'Modification d\'annonce',
  kyc_submit: 'Soumission KYC',
  kyc_approve: 'KYC validé',
  kyc_reject: 'KYC refusé',
  subscription: 'Abonnement',
  login: 'Connexion'
};

const MerchantActivity = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await verificationAPI.myActivity();
        setItems(res.data?.data || []);
      } catch (e) {} finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Historique d'activité</h1>
      {loading ? (
        <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600" /></div>
      ) : items.length === 0 ? (
        <div className="text-center text-gray-400 py-12">Aucune activité enregistrée.</div>
      ) : (
        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
          {items.map((a) => (
            <div key={a._id} className="p-4 flex items-start gap-3">
              <div className="w-9 h-9 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center shrink-0">
                <FiActivity size={16} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-medium text-gray-900">{TYPE_LABELS[a.type] || a.type}</div>
                {a.description && <div className="text-sm text-gray-500">{a.description}</div>}
              </div>
              <div className="text-xs text-gray-400 whitespace-nowrap">
                {new Date(a.createdAt).toLocaleString('fr-FR')}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MerchantActivity;
